export default "__VITE_ASSET__DCR6CizX__"